/**
 * Layout Component
 * Main layout wrapper with navigation and footer
 */

import React from 'react'
import Navigation from './Navigation'
import ContextBar from './ContextBar'
import FirstTimeUserBanner from './help/FirstTimeUserBanner'

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-slate-100 flex flex-col">
      <Navigation />
      <ContextBar />
      <main className="flex-1">
        {children}
      </main>
      <FirstTimeUserBanner />
    </div>
  )
}

export default Layout